export const environment = {
  production: true,
  base_url: 'https://api.acheiguapi.com.br/',
  version: '2.4.4',
  defaultSubDomain: 'acheiguapimirim',
  routeName: 'guapimirim',
  key_map: 'AIzaSyBhEbJ_HRKEIBIAllnIvZe8ch_NsQkm8Xs',
  whatsapp: '5521983542411', // Achei Guapimirim (cel José)
  // whatsapp: '5521993867618' // Achei Terê (2)
};
